




















































































import {
    computed,
    defineComponent,
    PropType,
    reactive,
    toRefs,
    ref,
    Ref,
} from '@vue/composition-api';
import { Maybe, Feed } from '@/generated-models';
import { plTooltip as PlTooltip } from '@ks/platform-ui';
import SocialShare from '@/components/social-share/index.vue';
import MoreOptions from './more.vue';
import { transformAtContent } from '@/common/util/parseText';
import { useLog } from '@/common/log';
import { useFeedInteractive } from '../hooks';
import { FeedMoreOptions } from '../types';
import { formatCount } from '@/common/util/time';
import { useFollowLottie, useIconLottie, useLikeLottie, useLottieUrlPrefix, useSidebarHover } from '../hooks/useLottie';
import { useRouter } from '@/common/utils';
import { appendParam } from '@/common/util/url';
import { debounce } from 'lodash';
import { useTip } from '../hooks/useTip';
export default defineComponent({
    props: {
        info: {
            type: Object as PropType<Maybe<Feed>>,
        },
        commentCount: {
            type: Number,
        },
        logType: {
            type: String,
            default: '',
        },
        videoIndex: {
            type: Number,
            default: 0,
        },
        isFullscreen: Boolean,
    },
    components: {
        SocialShare,
        PlTooltip,
        MoreOptions,
    },
    setup(props, { emit, root }) {
        const liked = ref(!!props.info?.photo?.liked);
        const realLikeCount = ref<number>(props.info?.photo?.realLikeCount || 0);
        const likeNumStr = computed(() => String(formatCount(realLikeCount.value)));
        const isFollowing = ref(!!props.info?.author?.following);
        const authorAvatarUrl = computed(() => props.info?.author?.headerUrl || '');
        const authorId = computed(() => props.info?.author?.id || '');
        const profileUrl = computed(() => `/profile/${authorId.value}`);
        const photoId = computed(() => props.info?.photo?.id || '');
        const expTag = computed(() => props.info?.photo?.expTag || '');
        const videoType = computed(() => props.info?.type || 1);
        const shareInfo = computed(() => ({
            title: transformAtContent(props.info?.photo?.originCaption || '', false),
            coverUrl: props.info?.photo?.coverUrl || '',
            nickname: props.info?.author?.name || '',
        }));
        const { route } = useRouter();
        const sharePath = computed(() => appendParam(`/short-video/${photoId.value}`, route.value?.query as Record<string, string>));
        const commentCountStr = computed(() => String(formatCount(props.commentCount || 0)));
        const state = reactive({
            shareBaseConfig: {
                subBiz: 'SINGLE_ROW_WEB',
                sdkVersion: '1.1.2.2.0',
            },
            ignoreOptions: ['streamSource'],
        });

        const { shareTip, moreTip, toolTipShow } = useTip();
        const currentPage = computed(() => root.$route?.meta?.page);
        const log = useLog();
        const { handleFollow, handleVideoLike, handleUninterested, handleReportPhoto }
            = useFeedInteractive(log, { logType: props.logType, currentPage: currentPage.value, isFollowing });
        function clickComment() {
            emit('click-sidebar', 'comment');
            log({
                type: 'CLICK',
                event_name: 'COMMENT_BUTTON',
            });
        }
        async function handleMoreOption(type: FeedMoreOptions) {
            if (type === 'uninterested') {
                const result = await handleUninterested(photoId.value, videoType.value, expTag.value);
                if (result === 1) {
                    emit('feedback-success');
                }
            } else {
                moreTip.value.hide();
                handleReportPhoto(photoId.value, authorId.value);
            }
        }
        const likeLottie = ref<HTMLDivElement | null>(null);
        const commentLottie = ref<HTMLDivElement | null>(null);
        const shareLottie = ref<HTMLDivElement | null>(null);
        const followLottie = ref<HTMLDivElement | null>(null);
        const lottiePrefix = useLottieUrlPrefix();
        const { playAnim, pauseAnim } = useIconLottie({
            iconDoms: [ commentLottie, shareLottie ],
            iconJsonUrls: [
                `${lottiePrefix}img/lottie/comment/comment.json`,
                `${lottiePrefix}img/lottie/share/share.json`,
            ],
        });
        const { commentBtn, shareBtn } = useSidebarHover(playAnim, pauseAnim);
        useFollowLottie(followLottie, `${lottiePrefix}img/lottie/follow/follow-success.json`, isFollowing);
        const { likeBtn, showLikeLottie, showUnlike } = useLikeLottie({
            lottieDom: likeLottie,
            liked,
            normalPath: `${lottiePrefix}img/lottie/like/like.json`,
            likedPath: `${lottiePrefix}img/lottie/like/liked-lottie/liked.json`,
            clickLikePath: `${lottiePrefix}img/lottie/like/click-like.json`,
            cancelPath: `${lottiePrefix}img/lottie/like/cancel-like.json`,
        });
        const clickLike = debounce(({
            photoId,
            authorId,
            expTag,
            videoIndex,
        }: { photoId: string; authorId: string; expTag: string; videoIndex: number }) => {
            handleVideoLike({ photoId, authorId, expTag, realLikeCount: realLikeCount, liked, videoIndex, showLikeLottie });
        }, 50);
        return {
            authorId,
            authorAvatarUrl,
            likeNumStr,
            profileUrl,
            photoId,
            shareInfo,
            isFollowing,
            expTag,
            commentCountStr,
            likeBtn,
            commentBtn,
            shareBtn,
            likeLottie,
            commentLottie,
            shareLottie,
            followLottie,
            sharePath,
            showUnlike,
            shareTip,
            moreTip,
            ...toRefs(state),
            handleFollow,
            clickLike,
            handleMoreOption,
            clickComment,
            toolTipShow,
        };
    },
});
